module.exports = __webpack_public_path__ + "adaa6f598548c6d178298a17ca791026.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/criminal.png
// module id = 603
// module chunks = 0